export default [
  [[1, 6], [2, 5], [3, 4]],
  [[5, 1], [6, 4], [2, 3]],
  [[1, 4], [5, 3], [6, 2]],
  [[3, 1], [4, 2], [5, 6]],
  [[1, 2], [3, 6], [4, 5]]
];
